// Reglas de negocio que deshabilitan cuentas en el árbol del clasificador.
// Viven acá, fuera de `SelectComponent` (genérico: solo entiende `disabled`
// y `disabled_reason` en cada opción), y las aplica quien sabe qué se está
// clasificando: `TreeClassificator`. Cada regla espeja un guard del backend
// (`save_prorate_tree`), así el usuario ve el motivo antes de chocar con el
// 400.
import { METADATA_OBLIGATION_BY_TYPE } from "@/utils/counterpartObligation";

// Decisiones §15 D2: la cuenta la alimenta el archivo de Ventas/Costos
// Devengados y se clasifica solo desde el archivo.
export const CV_FED_REASON =
    "Esta cuenta la alimenta el archivo de Ventas/Costos Devengados: se " +
    "clasifica solo desde el archivo (corrige el Excel y vuelve a subir el mes).";

// Decisiones §40 E2: la planilla de remuneraciones solo va a cuentas con
// «RR HH» en el nombre.
export const PAYROLL_ONLY_RRHH_REASON =
    "Las remuneraciones solo se clasifican en cuentas con RR HH en el nombre. " +
    "Elige una cuenta RR HH o pide al analista que la cree.";

export function isPayrollObligation(obligationName) {
    return obligationName === METADATA_OBLIGATION_BY_TYPE.Trabajador;
}

// Devuelve la cuenta con `disabled` / `disabled_reason` / `hidden` resueltos
// para el contexto dado. No muta la cuenta de entrada (viene del store).
//
// - cv-fed: deshabilitada con motivo (el usuario la ve en el reporte y debe
//   entender por qué no se le ofrece).
// - planilla → cuenta sin «RR HH»: OCULTA (Steve, 2026-10-14: la regla es
//   total y la lista completa estorba), salvo que sea una cuenta de la
//   clasificación vigente (`keepIds`): esa se conserva visible y
//   deshabilitada con motivo, porque el selector mostraría «Sin Clasificar»
//   si su valor desapareciera de las opciones.
export function accountOptionState(account, { obligationName, keepIds } = {}) {
    if (account.cv_fed) {
        return { ...account, disabled: true, disabled_reason: CV_FED_REASON, hidden: false };
    }
    if (isPayrollObligation(obligationName) && !account.rrhh_name) {
        const kept = Boolean(keepIds && keepIds.has(account.id));
        return {
            ...account,
            disabled: true,
            disabled_reason: PAYROLL_ONLY_RRHH_REASON,
            hidden: !kept,
        };
    }
    return { ...account, disabled: false, disabled_reason: null, hidden: false };
}

export function withAccountOptionRules(accounts, context) {
    return accounts
        .map((account) => accountOptionState(account, context))
        .filter((account) => !account.hidden);
}
